let swRegistration = null;
let isSubscribe = false;
const applicationServerPublicKey = 'BO_R6m8osilNmdOhEHk-KF0o1u-EPruOL1bDaISHwDwSLacPsh35Hg41nZpS00XeCLG-KbGEqx35x6PKsdZNVCk';
(() => {
    let btn = document.querySelector('button');

    if ('serviceWorker' in navigator && 'PushManager' in window) {
        navigator.serviceWorker.register('sw.js').then((swReg) => {
            swRegistration = swReg;
            //console.log(swRegistration);
            //alert("q");
            //btn.addEventListener('click', btnClick, true);
        }).catch((error) => {
            console.error('Service Worker Error', error);
        });
    } else {
        console.warn('Push messaging is not supported');
        btn.textContent = 'Push Not Supported';
    }
})();



// WEBPACK FOOTER //
// ./scripts/app.js